const pagesPersonImportCsvEn = {
  navigation: {
    section: {
      step1: "Upload file",
      step2: "Preview file",
      step3: "Import data",
    },
  },
  titleCard: {
    title: {
      step1: "1. Upload file",
      step2: "2. Preview file",
      step3: "3. Import data",
    },
  },
  prepareCsvFile: {
    title: "Prepare CSV file",
    useLastUploadedFile: "Use last uploaded file",
    download: "Download",
    uploadFileHere: "Upload file here",
    fileSizeError: "File size must be less than 10MB",
    template: "Template",
  },
  alertCard: {
    message: "Refer to errors found below and upload a corrected file again.",
    cells: "cells",
  },
  dataTableCard: {
    noResult: "No results.",
  },
  dockAddStepperAction: {
    next: "NextStep",
  },
  checkValidColumn: {
    errors: "Errors",
  },
  completeDialog: {
    message: "Successfully Imported!",
    button: "Go to Workforce",
  },
  processing: {
    upload: "Checking the uploaded file…",
    import: "Importing the data uploaded…",
    default: "Loading...",
  },
  workerType: {
    title: {
      employee: "Bulk Add Employee",
      contractor: "Bulk Add Contractor",
      boardMember: "Bulk Add Board Member",
      collaborator: "Bulk Add Collaborator",
    },
    filename: {
      // TODO: common.workerType に統一したい
      employee: "Employee",
      contractor: "Contractor",
      boardMember: "BoardMember",
      collaborator: "Collaborator",
    },
    prepareCsvFile: {
      templateTitle: {
        employee: "New employees",
        contractor: "New contractors",
        boardMember: "New boardMembers",
        collaborator: "New collaborators",
      },
      updateExisting: {
        employee: "Update existing employees",
        contractor: "Update existing contractors",
        boardMember: "Update existing boardMembers",
        collaborator: "Update existing collaborators",
      },
    },
    unit: {
      employees: "employees",
      contractors: "contractors",
      boardMembers: "boardMembers",
      collaborators: "collaborators",
    },
  },
};

export default pagesPersonImportCsvEn;
